module.exports = __webpack_public_path__ + "img/21_98.47d78ce6.png";